import { LoginMethodType, SigningMethodType } from './nativeProps';

export enum WebToRNAction {
    OPEN_EFAKTURA = 'OPEN_EFAKTURA',
    OPEN_PDF = 'OPEN_PDF',
    OPEN_SETTINGS = 'OPEN_SETTINGS', // This can be removed when minimum version Mitt Kort > v1.10.0
    LOGOUT = 'LOGOUT',
    OPEN_BROWSER = 'OPEN_BROWSER',
    OPEN_BROWSER_CALLBACK = 'OPEN_BROWSER_CALLBACK',
    COPY_TEXT = 'COPY_TEXT',
    SIGN = 'SIGN',
    OPEN_CHANGE_APPICON = 'OPEN_CHANGE_APPICON',
    OPEN_CHANGE_BANK = 'OPEN_CHANGE_BANK',
    TURN_ON_BIOMETRIC = 'TURN_ON_BIOMETRICS',
    TURN_OFF_BIOMETRIC = 'TURN_OFF_BIOMETRICS',
    SWITCH_BANK = 'SWITCH_BANK',
    SHOW_FEEDBACK_MODAL = 'SHOW_FEEDBACK_MODAL',
    SET_SIGNING_METHOD = 'SET_SIGNING_METHOD',
    SET_LOGIN_METHOD = 'SET_LOGIN_METHOD',
    STEP_UP_AUTH = 'STEP_UP_AUTH',
    WEBAPP_LOADED = 'WEBAPP_LOADED',
    GTP_TOKEN_STATUS = 'GTP_TOKEN_STATUS',
    GTP_PUSH_PROVISION = 'GTP_PUSH_PROVISION',
    GTP_WALLET_INFO = 'GTP_WALLET_INFO',
    GET_FCM_TOKEN = 'GET_FCM_TOKEN',
}

export interface SignEvent {
    bankIdUri?: string;
    dynamicLinkId: string;
}

export interface OpenBrowserCallbackEvent {
    uri: string;

    /**
     * in `some.scheme://myresult/ok`, `myresult/` is the callbackResultPrefix and `ok` is the result
     */
    callbackResultPrefix?: string;
}

export interface PdfEvent {
    url: string;
    title?: string;
}

export interface LogoutEvent {
    automaticLogout: boolean;
}

export interface GtpProvisionEvent {
    administrativeArea?: string;
    cardDisplayName: string;
    cardLastDigits: string;
    city?: string;
    countryCode?: string;
    networkCode: number;
    opc: string;
    phoneNumber?: string;
    postalCode?: string;
    tokenServiceProviderCode: number;
    userAddress1?: string;
    userAddress2?: string;
    userName?: string;
}

export interface GtpTokenStatusEvent {
    tokenReferenceId: string;
    tokenServiceProviderCode: number;
}

export type WebToRNPayloadList = {
    [WebToRNAction.OPEN_EFAKTURA]: string;
    [WebToRNAction.OPEN_PDF]: PdfEvent;
    [WebToRNAction.OPEN_SETTINGS]: undefined;
    [WebToRNAction.LOGOUT]: LogoutEvent;
    [WebToRNAction.OPEN_BROWSER]: string;
    [WebToRNAction.OPEN_BROWSER_CALLBACK]: OpenBrowserCallbackEvent;
    [WebToRNAction.COPY_TEXT]: string;
    [WebToRNAction.SIGN]: SignEvent;
    [WebToRNAction.OPEN_CHANGE_APPICON]: undefined;
    [WebToRNAction.OPEN_CHANGE_BANK]: undefined;
    [WebToRNAction.TURN_ON_BIOMETRIC]: undefined;
    [WebToRNAction.TURN_OFF_BIOMETRIC]: undefined;
    [WebToRNAction.SWITCH_BANK]: undefined;
    [WebToRNAction.SHOW_FEEDBACK_MODAL]: number;
    [WebToRNAction.SET_SIGNING_METHOD]: SigningMethodType;
    [WebToRNAction.SET_LOGIN_METHOD]: LoginMethodType;
    [WebToRNAction.STEP_UP_AUTH]: undefined;
    [WebToRNAction.WEBAPP_LOADED]: undefined;
    [WebToRNAction.GTP_TOKEN_STATUS]: GtpTokenStatusEvent;
    [WebToRNAction.GTP_PUSH_PROVISION]: GtpProvisionEvent;
    [WebToRNAction.GTP_WALLET_INFO]: undefined;
    [WebToRNAction.GET_FCM_TOKEN]: undefined;
};

export interface WebToRNMessage<Action extends keyof WebToRNPayloadList> {
    action: Action;
    payload: WebToRNPayloadList[Action];
}
